module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('vheader'), _c('mobile-nav'), _vm._m(0), _c('footer-user'), _c('vfooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("志愿者招募")])])]), _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "entry-list about"
  }, [_c('p', [_vm._v("前沿社长期招募志愿者，我们欢迎这样的你：")]), _c('ul', [_c('li', [_vm._v("热爱科技、充满好奇心")]), _c('li', [_vm._v("有相关科技行业相关实习经历，在读或者应届毕业生均可")]), _c('li', [_vm._v("具有良好的职业形象，沟通能力强，执行力强")]), _c('li', [_vm._v("熟练使用包括Keynote、Powerpoint等办公软件")]), _c('li', [_vm._v("英文听说读写熟练")])]), _c('p', [_vm._v("作为志愿者，你将有机会：")]), _c('ul', [_c('li', [_vm._v("实时了解最前沿的科学与技术潮流动态")]), _c('li', [_vm._v("每月与最优秀的创业者一同学习、思维保先")]), _c('li', [_vm._v("每季度近距离接触全球最权威的科技专家")])]), _c('p', [_vm._v("一年两次参与体验极客公园最强势IP大会的筹备全过程"), _c('br'), _c('br'), _vm._v("当然还有"), _c('br'), _vm._v("舒适愉快的办公环境"), _c('br'), _vm._v("美味可口的「极客食堂」"), _c('br'), _vm._v("欢迎投递简历至："), _c('a', {
    attrs: {
      "href": "mailto:thefrontier@geekpark.net"
    }
  }, [_vm._v("thefrontier@geekpark.net")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1301ce37!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Volunteers.vue
// module id = 189
// module chunks = 1